var exports = {
  "rY": "PlutoniumContent.module__giftModeContainer___MmpfNG",
  "rs": "PlutoniumContent.module__mainContainer___MmpfNG",
  "wx": "PlutoniumContent.module__header___MmpfNG",
  "DD": "PlutoniumContent.module__title___MmpfNG",
  "h_": "PlutoniumContent.module__description___MmpfNG",
  "xd": "PlutoniumContent.module__subscriptionSection___MmpfNG",
  "fv": "PlutoniumContent.module__disclaimerContainer___MmpfNG",
  "F4": "PlutoniumContent.module__perksSection___MmpfNG",
  "pD": "PlutoniumContent.module__comparisonTableContainer___MmpfNG",
};

module.exports = exports;
